import { render } from "./ClaimAttachment.vue?vue&type=template&id=216eab2c&scoped=true"
import script from "./ClaimAttachment.vue?vue&type=script&lang=js"
export * from "./ClaimAttachment.vue?vue&type=script&lang=js"

import "./ClaimAttachment.vue?vue&type=style&index=0&id=216eab2c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216eab2c"]])

export default __exports__